import axios from "axios";
import {toast} from "vue3-toastify";

// Base API URL
const API_BASE_URL = process.env.VUE_APP_API_URL;

// Create an Axios instance
const apiService = axios.create({
  baseURL: API_BASE_URL,
});

// API repository methods
const apiRepository = {
  POST_COMMAND: "POST",
  GET_COMMAND: "GET",
  PUT_COMMAND: "PUT",

  async callApi(method, endpoint, data = null) {
    const url = `${API_BASE_URL}${endpoint}`;
    try {
      const response = await axios({
        method: method,
        url: url,
        data: data,
      });
      return response;
    } catch (error) {
      console.error("API call failed:", error);
      toast.error(error.response.data);
      // throw error;
    }
  },

  async getRelevantList() {
    try {
      const lang = localStorage.getItem("locale") || "en";
      const response = await apiService.get(`/relevantList?lang=${lang}`);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  },
  async getMedia() {
    return import.meta.env.VITE_API_URL + '/raw-media/'
  },
};

export default apiRepository;

export function getImage() {
  return process.env.VUE_APP_API_URL + '/raw-image/';
}
export function getMediaInfo() {
  return process.env.VUE_APP_API_URL + '/raw-media-info/';
}

